import React from 'react';

import './RoundButton.scss';

const RoundButton = props => <button {...props} className={`round-button ${props.className}`} />;

export default RoundButton;
